module.exports = __webpack_public_path__ + "static/media/file-upload-close.5ed3b043.svg";